
import * as React from 'react';
import { IControlFaceted, renderChildrenWithControlHandlers } from '../decorators/withControlHandler';
import { itemCacheSuspenseControl, ItemCacheSuspenseMode } from '../../controls/itemCacheSuspenseControl';
import { IItemCache } from '../../models/IItemCacheObserver';
import { mapObject } from '../../utilities/objects';
import { IReactChildrenProps } from '../../utilities/components/Props';

const controlHandlersByMode: {
  [P in ItemCacheSuspenseMode]: IControlFaceted;
} = mapObject({
  debounce: true
}, (value: boolean, mode: ItemCacheSuspenseMode) => {
  return itemCacheSuspenseControl.pack((
    // Never used.
    itemCache: IItemCache,
    props: typeof itemCacheSuspenseControl.inputType
  ): typeof itemCacheSuspenseControl.returnType => {
    if (props.mode) {
      // If a closer ItemCacheSuspense applies to a component, prefer it instead of overriding.
      return {};
    }

    return {
      mode
    };
  });
});

export interface IItemCacheSuspenseProps {
  mode: ItemCacheSuspenseMode;
}

export const ItemCacheSuspense: React.ComponentType<IItemCacheSuspenseProps> = (
  props: IItemCacheSuspenseProps & IReactChildrenProps
): JSX.Element => {
  return renderChildrenWithControlHandlers(props.children, controlHandlersByMode[props.mode]);
};
